var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    [
      _c(
        "v-dialog",
        {
          attrs: { lazy: "", persistent: "", "max-width": "500" },
          on: {
            input: function(v) {
              return v
            }
          },
          model: {
            value: _vm.showDispatchDialog,
            callback: function($$v) {
              _vm.showDispatchDialog = $$v
            },
            expression: "showDispatchDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _c("span", { staticClass: "title mb-3" }, [_vm._v("Accept")]),
                  _vm._v(" "),
                  _c("i", [
                    _vm._v("Available loads: " + _vm._s(_vm.availableLoads))
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value:
                          "required|min_value:1|max_value:" +
                          _vm.availableLoads,
                        expression:
                          "`required|min_value:1|max_value:${availableLoads}`"
                      }
                    ],
                    attrs: {
                      items: _vm.loadsOptions,
                      "error-messages": _vm.errors.first(
                        "acceptedDispatchLoads",
                        "modal"
                      ),
                      "data-vv-as": "Accepted Loads",
                      "data-vv-name": "acceptedDispatchLoads",
                      "data-vv-scope": "modal",
                      label: "Accepted Loads"
                    },
                    model: {
                      value: _vm.acceptedDispatchLoads,
                      callback: function($$v) {
                        _vm.acceptedDispatchLoads = _vm._n($$v)
                      },
                      expression: "acceptedDispatchLoads"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "accent",
                            loading:
                              _vm.loadingDispatchRequests || _vm.loadingBtn,
                            disabled: _vm.errors.any("modal")
                          },
                          on: {
                            click: function($event) {
                              return _vm.acceptDispatchAssignment()
                            }
                          }
                        },
                        [_vm._v("\n            Accept\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent", flat: "" },
                          on: {
                            click: function($event) {
                              _vm.showDispatchDialog = false
                            }
                          }
                        },
                        [_vm._v("\n            Cancel\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-master-detail-pane",
        {
          attrs: { selected: _vm.selectedLoad },
          on: {
            reset: function($event) {
              return _vm.selectLoad(null)
            }
          }
        },
        [
          _c(
            "template",
            { slot: "master" },
            [
              _vm.dispatchRequests
                ? _c("v-load-nav-list", {
                    attrs: {
                      dispatched: "",
                      title: "Dispatch Requests",
                      searchPrompt: "Search Dispatch Requests",
                      loading: _vm.loadingDispatchRequests,
                      accurateSince: _vm.accurateSince,
                      loads: _vm.filteredDispatchRequests,
                      carrierLoads: _vm.groupedByDispatcherLoads,
                      company: _vm.company
                    },
                    on: {
                      "update:searchTerm": function($event) {
                        _vm.search = $event
                      },
                      refresh: _vm.reloadDispatchRequests
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "loadTile",
                          fn: function(ref) {
                            var idx = ref.idx
                            var dispatch = ref.load
                            return [
                              _c(
                                "v-list-tile",
                                {
                                  key:
                                    "dispatched_load_" +
                                    idx +
                                    "_" +
                                    dispatch.humanId,
                                  class: {
                                    "primary lighten-1": _vm.isSelectedLoad(
                                      dispatch
                                    )
                                  },
                                  attrs: {
                                    inactive: _vm.isSelectedLoad(dispatch),
                                    ripple: "",
                                    avatar: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.selectLoad(dispatch)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.loadGroupOwnerName(dispatch)
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-sub-title",
                                        { staticClass: "text--primary" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(dispatch.humanId) +
                                              ": $" +
                                              _vm._s(dispatch.payableAmount) +
                                              " ($" +
                                              _vm._s(
                                                _vm.pricePerDistance(dispatch)
                                              ) +
                                              "/" +
                                              _vm._s(
                                                _vm.siteDistanceMeasurePerLabel
                                              ) +
                                              ")\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("v-list-tile-sub-title", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm._f("formatShortDate")(
                                                dispatch.loadGroup
                                                  .scheduledPickupTime
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            color: "primary",
                                            "text-color": "white",
                                            small: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.dispatchRequestVisibleCount(
                                                  dispatch
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider", {
                                key:
                                  "dispatched_divider_" +
                                  idx +
                                  "_" +
                                  dispatch.humanId
                              })
                            ]
                          }
                        },
                        {
                          key: "carrierLoadsTile",
                          fn: function(skope) {
                            return [
                              _c(
                                "v-list-group",
                                { key: "groupedBy_" + skope.idx },
                                [
                                  _c(
                                    "v-list-tile",
                                    {
                                      attrs: { slot: "activator" },
                                      slot: "activator"
                                    },
                                    [
                                      _c(
                                        "v-list-tile-action",
                                        [
                                          _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                color: "primary",
                                                "text-color": "white",
                                                small: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.loadGroupCollectionTruckCount(
                                                      skope.loads
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(skope.carrier) +
                                            "\n              "
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(skope.loads, function(load) {
                                    return [
                                      _c(
                                        "v-list-tile",
                                        {
                                          key: "grouped_load_" + load.humanId,
                                          class: {
                                            "primary lighten-1": _vm.isSelectedLoad(
                                              load
                                            )
                                          },
                                          attrs: {
                                            inactive: _vm.isSelectedLoad(load),
                                            ripple: "",
                                            avatar: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.selectLoad(load)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _vm.loadGroupCustomerCompanyName
                                                ? _c("v-list-tile-title", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.loadGroupCustomerCompanyName(
                                                          load
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-sub-title",
                                                {
                                                  staticClass: "text--primary"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(load.humanId) +
                                                      ": $" +
                                                      _vm._s(
                                                        load.payableAmount
                                                      ) +
                                                      " ($" +
                                                      _vm._s(
                                                        _vm.pricePerDistance(
                                                          load
                                                        )
                                                      ) +
                                                      "/" +
                                                      _vm._s(
                                                        _vm.siteDistanceMeasurePerLabel
                                                      ) +
                                                      ")\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm._f("formatShortDate")(
                                                        load.loadGroup
                                                          .scheduledPickupTime
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider", {
                                        key: "load_divider_" + load.humanId
                                      })
                                    ]
                                  })
                                ],
                                2
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2265712615
                    )
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "detail" },
            [
              _c(
                "v-load-group-details",
                {
                  attrs: {
                    dispatched: "",
                    disableAddressView: "",
                    "group-booked-loads": _vm.bookedContracts,
                    "planning-load": _vm.selectedLoad,
                    company: _vm.company,
                    "banner-title": "Preferred Carrier Dispatch Requests",
                    loading: _vm.loadingLoad
                  },
                  on: {
                    reload: function($event) {
                      return _vm.onRefresh()
                    }
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "toolbarButtons" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", color: "accent" },
                          on: { click: _vm.openAcceptDialog }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { column: "" } },
                            [
                              _c("v-icon", [_vm._v("add_box")]),
                              _vm._v("\n              Accept\n            ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-acbceaf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acbceaf6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/simple/DispatchedLoadRequests.vue
// module id = null
// module chunks = 